const about = `
<h1 class="text-base" ><b>Coming in 2023</b></h1>
<p>Until stated otherwise, Swivu is a pre-beta, experimental site. You are welcome to try Swivu; however at this time, we do not offer support or guarantees.</p>
<!-- -->
<h1 class="text-base mt-5" ><b>Hidden Features</b></h1>
<p>Right click on columns, rows, and cells to uncover additional features.</p>
<!-- -->
<h1 class="text-base mt-5" ><b>Limited Features</b></h1>
<p>If you don't login with Google, after you close your browser tab, your data will be lost. Messaging and emailing from Swivu is limited to our pilot program participants.</p>
<!-- -->
<h1 class="text-base mt-5" ><b>Rapidly Evolving</b></h1>
<p>The user interface you see today, will not be the user interface you see next week.</p>
<!-- -->
<h1 class="text-base mt-5" ><b>What is Swivu?</b></h1>
<p>Delegate tasks to teams on a timeline in seconds. Throughout 2023, we intend to turn Swivu into the most efficient way to delegate tasks to resources by date and time.</p>
<!-- -->
<h1 class="text-base mt-5" ><b>What are tasks?</b></h1>
<p>In Swivu, projects, jobs, and tasks in Swivu are all called "tasks".</p>
<!-- -->
<h1 class="text-base mt-5" ><b>What are resources?</b></h1>
<p>In Swivu, workers, employees, team members, subcontractors, gig workers, vehicles, equipment, and tools are all called "resources".</p>
<!-- -->
<h1 class="text-base mt-5" ><b>How do I begin?</b></h1>
<p>You have to enter at least one resource to begin. After that, you can click anywhere on the schedule to assign a [new] task to your resource(s).</p>
<!-- -->
<h1 class="text-base mt-5" ><b>Who are you building Swivu for?</b></h1>
<p>In many small to mid-sized businesses, the person that delegates daily tasks to resources is often the owner, the CEO, or someone occupying a senior management position. Our goal is to make these "schedulers' ("the boss"), their resources, and their clients productive and happy."</p>
<!-- -->
<h1 class="text-base mt-5" ><b>What industry segments are you targeting?</b></h1>
<p>Swivu will be a general purpose scheduling tool that can be used within any organization. However, in 2023 we are focused on niches where daily tasks are assigned to blue-collar workforces (e.g.: construction, maintenance, contracting, and municipal workforces).</p>
<!-- -->
<h1 class="text-base mt-5" ><b>How much will Swivu cost?</b></h1>
<p>There will be a free, limited trial period; after that, we intend to sell affordable and flexible access to Swivu on a token-basis. Token access will also enable you to control access to your scheduling information by resource, by client, and down to the day. We are aligning our business model with your need to flexibly employ gig workers, subcontractors, and other leased or rented resources.</p>
<!-- -->
<h1 class="text-base mt-5" ><b>Can I join the Swivu Pilot Program?</b></h1>
<p>We are onboarding a limited number of pilot users that are trading feedback and patience for support and a cache of access tokens (for future use). If you would like to be a Swivu pioneer, please fill out this form [link] and we will reply within 72 hours.</p>
<!-- -->
<h1 class="text-base mt-5" ><b>Who's behind Swivu?</b></h1>
<p>We are based in Massachusetts. Our team is global and remote. The leadership team has been successfully building software, startups, and other businesses for over thirty years.</p>
<!-- -->
<h1 class="text-base mt-5" ><b>Elevator Pitch</b></h1>
<p>Millions of people use Excel, Sheets, and even Trello for scheduling. Swivu is the upgrade.</p>
<!-- -->
<h1 class="text-base mt-5" ><b>Is Swivu hiring?</b></h1>
<p>Senior React, React Native, Javascript, and Python engineers...join the founding team [link]. We are not hiring business folks at this time.</p>
<!-- -->
<h1 class="text-base mt-5" ><b>Can I invest?</b></h1>
<p>Swivu is privately funded. There will be an investment opportunity in 2023 for accredited investors.</p>
<!-- -->
<h1 class="text-base mt-5" ><b>Where did the name Swivu come from?</b></h1>
<p>The only way to view schedule information by resource and/or alternately by task is to "swivel" or pivot the information. We swivu the scheduling information into a [read only] pivot view we call the "plan" (under construction).</p>
<!-- -->
<h1 class="text-base mt-5" ><b>Product Roadmap</b></h1>
<p>We are constantly updating our roadmap [link].</p>
<!-- -->
<h1 class="text-base mt-5" ><b>Contact</b></h1>
<p>Please send all correspondence to swivu@swivu.com</p>
`;

export default about;
